import React from 'react';
import '../../../css/MenuAvailabilityComponent.css'; // Import your CSS file for styling
import { setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from '../../../utility';
import { t } from 'i18next';

function MenuAvailabilityComponent({ availability }) {
    const { type } = availability;

    const renderAvailability = () => {
        if (type === 'always') {
            return (
                <p className="always-availability-text sub-text text-center sub-font" style={{ color: setMobileTextColor() }}>
                    {t("The menu is always available.")}
                </p>
            );
        } else if (type === 'specific_dates') {
            const { from_date, from_time, to_date, to_time } = availability;
            return (
                <div className="availability-text alignByLang" style={{ color: setMobileTextColor() }}>
                    <p className="availability-text head-font" style={{ color: setMobileTextColor() }}>
                        {t("Opening hours")}
                    </p>
                    <div className="availability-card-container alignByLang text-center">
                        <div className="availability-row">
                            <div className="availability-label sub-font" style={{ color: setMobileTextColor() }}>
                                {t("From")} 
                            </div>
                            <div className="availability-value sub-font" style={{ color: setMobileTextColor() }}>
                                {from_date || "--"}{" "}{from_time || ""}
                            </div>
                        </div>
                        <div className="availability-row">
                            <div className="availability-label sub-font" style={{ color: setMobileTextColor() }}>
                                {t("To")}
                            </div>
                            <div className="availability-value sub-font" style={{ color: setMobileTextColor() }}>
                                {to_date || "--"}{" "}{to_time || ""}
                            </div>
                        </div>
                    </div>
                </div>

            );
        } else if (type === 'periodic') {
            return (

                <div className='alignByLang'>
                    <p className="availability-text head-font" style={{ color: setMobileTextColor() }}>
                        {t("Opening hours")}
                    </p>
                    <div className="availability-card-container">
                        {["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
                            <div className="day-time-row" key={day}>
                                <div className="day sub-font" style={{ color: setMobileTextColor() }}>
                                    {t(day)}
                                </div>
                                <div className="time sub-font" style={{ color: setMobileTextColor() }}>
                                    {`${availability[`${day.toLowerCase()}_from`] || "--:--"} - ${availability[`${day.toLowerCase()}_to`] || "--:--"}`}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        } else {
            return (
                <p className="availability-text sub-font" style={{ color: setMobileTextColor() }}>
                    {t("No availability information available.")}
                </p>
            );
        }
    };

    return (
        <div style={{ backgroundColor: setMobileBackColor(), borderColor: setMobileCardBorderColor() }} className="availability-container sub-font">
            {renderAvailability()}
        </div>
    );
}

export default MenuAvailabilityComponent;
